import React, { useState } from 'react';
import * as styles from './FloatingPanel.module.css';

interface FloatingPanelProps {
  title: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
  position?: 'left' | 'right';
  open?: boolean;
}

const UpArrow = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 15L12 9L6 15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DownArrow = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 9L12 15L18 9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FloatingPanel: React.FC<FloatingPanelProps> = ({
  title,
  icon,
  children,
  position = 'right',
  open = false,
}) => {
  const [isOpen, setIsOpen] = useState(open);

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <div className={`${styles.panel} ${isOpen ? styles.open : ''} ${styles[position]}`}>
      <div className={styles.header} onClick={toggleOpen} style={{ height: 50 }}>
        <div className={styles.icons}>
          {icon}
          <h3>{title}</h3>
        </div>
        <button className={styles.iconButton}>{isOpen ? <DownArrow /> : <UpArrow />}</button>
      </div>
      <div className={`${styles.content} ${isOpen ? styles.contentOpen : ''}`}>
        <div className={styles.inner}>{children}</div>
      </div>
    </div>
  );
};
